type AuthLike = {
  userId: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
};

export type SettingsPermissions = {
  isSuperAdmin: boolean;
  isAdmin: boolean;
  canEditTeamUser: boolean;
  canEditVoice: boolean;
};

/**
 * Centralized permission rules for the settings page.
 *
 * - Superadmin (or anyone impersonating, since only superadmins can impersonate): all access.
 * - Admin: can edit any user on their team.
 * - Regular user: can only edit their own settings; cannot change voice (admin/superadmin only).
 */
export function getSettingsPermissions(
  authData: AuthLike,
  targetUserId: string,
  isImpersonating: boolean,
): SettingsPermissions {
  const isSuperAdmin = authData.isSuperAdmin || isImpersonating;
  const isAdmin = authData.isAdmin || isSuperAdmin;
  const isOwn = authData.userId === targetUserId;
  return {
    isSuperAdmin,
    isAdmin,
    canEditTeamUser: isSuperAdmin || isAdmin || isOwn,
    canEditVoice: isSuperAdmin || isAdmin,
  };
}
